import React, { PropsWithChildren } from 'react';

export const headingContext = React.createContext(0);

const HeadingContext: React.FC<PropsWithChildren> = ({ children }) => {
  const headingLevel = React.useContext(headingContext);

  return <headingContext.Provider value={headingLevel + 1}>{children}</headingContext.Provider>;
};

export default HeadingContext;
